import axios from 'axios';
import QS from 'qs'
import Vue from 'vue'
import store from '../store/index'
import { Message } from 'element-ui';
import Router from 'vue-router'
import router from '../router'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
    return originalPush.call(this, location).catch(err => err)
}

axios.defaults.baseURL = ' '

// 统一的 401 处理函数
function handle401() {
    // 清除登录信息
    localStorage.removeItem('name')
    localStorage.removeItem('access_token')
    localStorage.removeItem('id')
    localStorage.removeItem('username')
    localStorage.removeItem('userpass')
    
    // 清除 store 中的 token
    store.commit('setaccess_token', null)
    
    // 弹出警告提示
    // Message.warning({
    //     message: '登录已失效，请重新登录',
    //     duration: 2000
    // })
    
    // 返回首页并弹出登录框
    router.push('/')
    setTimeout(() => {
        store.commit('setLoginType', true)
        store.commit('setRegisterType', null)
    }, 500)
}

export function request({ method, url, params, _type }) { 

    const access_token = localStorage.getItem('access_token')
    if(!_type){
        if(!access_token){
            // 未登录时，由路由守卫处理，这里不重复处理
            // 直接返回错误，避免发送无效请求
            return Promise.reject('未登录')
        }
    }

    
    if (method == "get") {
        return get(url, params,_type)
    } else if (method == "post") {
        return post(url, params,_type)
    } else if (method == "formdata") {
        return formdata(url, params,_type)
    }
    
    // 未知 method，返回错误
    return Promise.reject('未知的请求方法：' + method)
}

var get = function(url, params, _type) {
    return new Promise((resolve, reject) => {
        let data = params;
        axios({
            method: 'get',
            url: url,
            params: data
        }).then(res => {
            resolve(res.data)
            // 统一处理 401 状态码
            if(res.data.code == 401 || res.data.msg == '登录失效，请重新登录'){
                handle401()
            }
        }).catch(err => {
            // 处理 HTTP 状态码 401
            if(err.response && err.response.status === 401){
                handle401()
            }
            reject(err)
        })
    })
}
var post = function(url, params, _type) {
    return new Promise((resolve, reject) => {
        let data = params;
        axios({
            method: 'post',
            url: url,
            data: QS.stringify(data)
        }).then(res => {
            resolve(res.data)
            // 统一处理 401 状态码
            if(res.data.code == 401 || res.data.msg == '登录失效，请重新登录'){
                handle401()
            }
        }).catch(err => {
            // 处理 HTTP 状态码 401
            if(err.response && err.response.status === 401){
                handle401()
            }
            reject(err)
        })
    })
}
var formdata = function(url, params, _type) {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: url,
            data: params
        }).then(res => {
            resolve(res.data)
            // 统一处理 401 状态码
            if(res.data.code == 401 || res.data.msg == '登录失效，请重新登录'){
                handle401()
            }
        }).catch(err => {
            // 处理 HTTP 状态码 401
            if(err.response && err.response.status === 401){
                handle401()
            }
            reject(err)
        })
    })
}